export const rotateImg = (url, rotate, callback) => {
  try {
    let img = new Image();
    img.setAttribute('crossOrigin', 'anonymous');
    // img.setAttribute('Access-Control-Allow-Origin',"*");
    img.src = url + '?tamp=' + (new Date()).valueOf();

    if (rotate) {
      if (rotate !== 90 && rotate !== -90 && rotate !== 180) {
        rotate = null;
      }
    }

    img.onload = function (ev) {
      console.log("img.onload");
      let originWidth = this.width;
      let originHeight = this.height;
      let targetWidth = originWidth;
      let targetHeight = originHeight;

      let maxWidth = 1920,
        maxHeight = 1920;

      if (originWidth > maxWidth || originHeight > maxHeight) {
        if (originWidth / originHeight > maxWidth / maxHeight) {
          targetWidth = maxWidth;
          targetHeight = Math.round(maxWidth * (originHeight / originWidth));
        } else {
          targetHeight = maxHeight;
          targetWidth = Math.round(maxHeight * (originWidth / originHeight));
        }
      }
      console.log("Test Rotate 30L");
      let canvas = document.createElement('canvas');
      let context = canvas.getContext('2d');
      canvas.width = targetWidth;
      canvas.height = targetHeight;
      context.clearRect(0, 0, targetWidth, targetHeight);
      context.drawImage(img, 0, 0, originWidth, originHeight, 0, 0, targetWidth, targetHeight);
      
      let dataUrl = canvas.toDataURL("image/jpeg");

      if (rotate) {
        let angle = 0;
        let canvas2 = document.createElement('canvas');
        let context2 = canvas2.getContext('2d');
        canvas2.width = targetWidth;
        canvas2.height = targetHeight;

        let _setting = {
          dx: 0,
          dy: 0,
          dw: 0,
          dh: 0,
          transX: 0,
          transY: 0
        };
        let scale = 0;
        if (rotate === 180) {
          angle = Math.PI;
          _setting.dw = targetWidth;
          _setting.dh = targetHeight;
          context2.translate(targetWidth, targetHeight);
          context2.rotate(angle);
          context2.translate(0, 0);
        } else {
          if (rotate === 90) {
            angle = 90 * (Math.PI / 180);
          } else if (rotate === -90) {
            angle = -90 * (Math.PI / 180);
          }
          canvas2.width = targetHeight;
          canvas2.height = targetWidth;

          _setting.transX = parseFloat(targetHeight / 2);
          _setting.transY = parseFloat(targetWidth / 2);
          _setting.dw = targetHeight;
          scale = targetWidth / targetHeight;
          _setting.dh = parseFloat(_setting.dw / scale);
          _setting.dy = (targetWidth - _setting.dh) / 2;
          context2.translate(_setting.transX, _setting.transY);
          context2.rotate(angle);
          context2.scale(scale, scale);
        }
        console.log("Test Rotate 83L");
        /**
         * ctx.drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
         *
         * image: 可以是一个image ，或者一个canvas
         * sx: 在画布所绘制图片本身的x轴的距离
         * sy: 在画布所绘制图片本身y轴的距离
         * sWidth:表示所绘制图片的宽度范围，一般默认是图片的完整大小。也可以是部分绘制。
         * sHeight:表示所绘制图片的高度范围，一般默认是图片的完整大小。也可以是部分绘制。
         * dx:表示在画布x轴的坐标值
         * dy:表示在画布y轴的坐标值
         * dWidth: 在画布绘制的宽度
         * dHeight:在画布绘制的长度
         */
        context2.drawImage(canvas, 0, 0, targetWidth, targetHeight, _setting.dx - _setting.transX, _setting.dy - _setting.transY, _setting.dw, _setting.dh);
        dataUrl = canvas2.toDataURL("image/jpeg");
      }
      callback(dataUrl);
    };
  } catch (ex) {
    console.error(ex.toString());
  }

}

export const rotateImgBase64 = (url, rotate, callback) => {
  try {
    let img = new Image();
    img.src = url;
    
    if (rotate) {
      if (rotate !== 90 && rotate !== -90 && rotate !== 180) {
        rotate = null;
      }
    }

    img.onload = function (ev) {
      console.log("img.onload");
      let originWidth = this.width;
      let originHeight = this.height;
      let targetWidth = originWidth;
      let targetHeight = originHeight;

      let maxWidth = 1920,
        maxHeight = 1920;

      if (originWidth > maxWidth || originHeight > maxHeight) {
        if (originWidth / originHeight > maxWidth / maxHeight) {
          targetWidth = maxWidth;
          targetHeight = Math.round(maxWidth * (originHeight / originWidth));
        } else {
          targetHeight = maxHeight;
          targetWidth = Math.round(maxHeight * (originWidth / originHeight));
        }
      }
      console.log("Test Rotate 30L");
      let canvas = document.createElement('canvas');
      let context = canvas.getContext('2d');
      canvas.width = targetWidth;
      canvas.height = targetHeight;
      context.clearRect(0, 0, targetWidth, targetHeight);
      context.drawImage(img, 0, 0, originWidth, originHeight, 0, 0, targetWidth, targetHeight);
      
      let dataUrl = canvas.toDataURL("image/jpeg");

      if (rotate) {
        let angle = 0;
        let canvas2 = document.createElement('canvas');
        let context2 = canvas2.getContext('2d');
        canvas2.width = targetWidth;
        canvas2.height = targetHeight;

        let _setting = {
          dx: 0,
          dy: 0,
          dw: 0,
          dh: 0,
          transX: 0,
          transY: 0
        };
        let scale = 0;
        if (rotate === 180) {
          angle = Math.PI;
          _setting.dw = targetWidth;
          _setting.dh = targetHeight;
          context2.translate(targetWidth, targetHeight);
          context2.rotate(angle);
          context2.translate(0, 0);
        } else {
          if (rotate === 90) {
            angle = 90 * (Math.PI / 180);
          } else if (rotate === -90) {
            angle = -90 * (Math.PI / 180);
          }
          canvas2.width = targetHeight;
          canvas2.height = targetWidth;

          _setting.transX = parseFloat(targetHeight / 2);
          _setting.transY = parseFloat(targetWidth / 2);
          _setting.dw = targetHeight;
          scale = targetWidth / targetHeight;
          _setting.dh = parseFloat(_setting.dw / scale);
          _setting.dy = (targetWidth - _setting.dh) / 2;
          context2.translate(_setting.transX, _setting.transY);
          context2.rotate(angle);
          context2.scale(scale, scale);
        }
        console.log("Test Rotate 83L");
        /**
         * ctx.drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
         *
         * image: 可以是一个image ，或者一个canvas
         * sx: 在画布所绘制图片本身的x轴的距离
         * sy: 在画布所绘制图片本身y轴的距离
         * sWidth:表示所绘制图片的宽度范围，一般默认是图片的完整大小。也可以是部分绘制。
         * sHeight:表示所绘制图片的高度范围，一般默认是图片的完整大小。也可以是部分绘制。
         * dx:表示在画布x轴的坐标值
         * dy:表示在画布y轴的坐标值
         * dWidth: 在画布绘制的宽度
         * dHeight:在画布绘制的长度
         */
        context2.drawImage(canvas, 0, 0, targetWidth, targetHeight, _setting.dx - _setting.transX, _setting.dy - _setting.transY, _setting.dw, _setting.dh);
        dataUrl = canvas2.toDataURL("image/jpeg");
      }
      callback(dataUrl);
    };
  } catch (ex) {
    console.error(ex.toString());
  }

}


// export const dataURLtoFile = (dataUrl, filename) => {
//     const arr = dataUrl.split(',')
//     const mime = arr[0].match(/:(.*?);/)[1]
//     const bstr = atob(arr[1])
//     let n = bstr.length
//     let u8arr = new Uint8Array(n);
//     while (n--) {
//         u8arr[n] = bstr.charCodeAt(n);
//     }
//     return new File([u8arr], filename, {type: mime});
// }
export const dataURLtoFile = (dataUrl, filename) => {
  const arr = dataUrl.split(',')
  const bstr = window.atob(arr[1])
  let n = bstr.length;
  let u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {
    type: 'image/jpeg'
  });
}


// WEBPACK FOOTER //
// ./src/components/ImgFilp/canvas-rotate-image.js